<template>
    <ul class="mainmenu">
        <li v-for="(item, index) in visibleItems"
            :class="[item.hasDropdown ? 'has-droupdown has-menu-child-item' : '', item.megamenu ? 'with-megamenu' : '']"
            :key="`nav-item-${index}`">
            <!-- 主导航链接：添加高亮+横杠效果 -->
            <div @click="goCollege(item)">
                <router-link :to="item.link?item.link:''" class="nav-link its_new" :class="{ 'active': isRouteActive(item.link) }">
                    <span class="" style="white-space: nowrap;">{{ item.title }} </span>

                    <span class="nav-bar"></span> <!-- 底部横杠元素 -->
                </router-link>
            </div>


            <!-- 下拉菜单：保留原注释，没配置的不显示 -->
            <ul v-if="item.hasDropdown" class="submenu">
                <li v-for="(subMenuItem, subMenuIndex) in item.dropdownItems" :key="`sub-menu-item-${subMenuIndex}`">
                    <router-link :to="subMenuItem.link?subMenuItem.link:''"
                        :class="[subMenuItem.class || '', { 'active': isRouteActive(subMenuItem.link) }]">
                        {{ subMenuItem.title }}
                        <i v-if="subMenuItem.class !== 'live-expo'" :class="`feather-${subMenuItem.icon}`" />
                    </router-link>
                </li>
            </ul>

            <!-- 巨型菜单：保留原配置，没数据的不显示 -->
            <div v-if="item.megamenu" class="rn-megamenu">
                <div class="wrapper">
                    <div class="row row--0">
                        <div v-for="(megamenuItem, megamenuIndex) in item.megaMenuItems"
                            :key="`mega-menu-item-${megamenuIndex}`" class="col-lg-3 single-mega-item">
                            <ul class="mega-menu-item">
                                <li v-for="(megamenuSubItem, megamenuSubIndex) in megamenuItem.items"
                                    :key="`mega-submenu-item-${megamenuSubIndex}`">
                                    <router-link :to="megamenuSubItem.link?megamenuSubItem.link:''">
                                        {{ megamenuSubItem.title }}

                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'Nav',
    props: {
        // 桌面端导航隐藏 APP 下载项（APP 在头部右侧独立为黄色按钮）；
        // 移动端弹窗菜单不传该属性，保持原有列表不变
        hideAppBtn: { type: Boolean, default: false }
    },
    computed: {
        visibleItems() {
            return this.navItems.filter(item => !(this.hideAppBtn && item.appBtn));
        }
    },
    data() {
        return {
            navItems: [
                {
                    link: '/',
                    title: this.$t('information.homePage'),
                    hasDropdown: false,
                    megamenu: false,
                    dropdownItems: [
                        { link: '/', title: 'Home Page-01' },
                        // {link: '/index-02', title: 'Home Page-02', icon: 'home'},
                        // 其他注释的子路由不显示
                    ]
                },
                {
                    link: '/blog-single-column',
                    title: this.$t('about.SimplifiedName'),
                    hasDropdown: false,
                    megamenu: false,
                },
                // 资讯中心（暂时注释掉）
                // {
                //     link: '/blog-col-three',
                //     title: this.$t('information.name'),
                //     hasDropdown: false,
                //     megamenu: false,
                //     dropdownItems: [
                //         { link: '/blog-single-column', title: 'Blog Single Column', icon: 'fast-forward' },
                //         { link: '/blog-col-two', title: 'Blog Two Column', icon: 'fast-forward' },
                //         { link: '/blog-col-three', title: 'Blog Three Column', icon: 'fast-forward' },
                //         { link: '/blog', title: 'Blog Four Column', icon: 'fast-forward' },
                //         { link: '/blog-details/1', title: 'Blog Details', icon: 'fast-forward' }
                //     ]
                // },
                {
                    link: '/yantai-ai',
                    title: this.$t('about.aiName'),
                    hasDropdown: false,
                    megamenu: false,
                },
                {
                    // link:'',
                    url: 'https://study.matrixpower.club/',
                    title: this.$t('college'),
                    type: '1',
                    hasDropdown: false,
                    megamenu: false,
                    megaMenuItems: [
                    ]
                },
                {
                    // link:'',
                    // 衍泰WEB3：与衍泰学院同为外链跳转，地址暂未配置（为空时不打开新窗口）
                    url: '',
                    title: this.$t('web3'),
                    type: '1',
                    hasDropdown: false,
                    megamenu: false,
                    megaMenuItems: [
                    ]
                },
                {
                    link: '/blog-col-two',
                    title: this.$t('appDownload.download'),
                    appBtn: true,
                    hasDropdown: false,
                    megamenu: false,
                    megaMenuItems: [
                    ]
                },

                {
                    link: '/about',
                    title: this.$t('about.titleName1'),
                    hasDropdown: false,
                    megamenu: false,
                },
                {
                    link: '/contact',
                    title: this.$t('contact.name'),
                    hasDropdown: false,
                    megamenu: false,
                }
            ]
        }
    },
    methods: {
        goCollege(item) {
            console.log(1111, item.url);
            if (item.type == 1 && item.url) {
                window.open(item.url);
            }
        },
        // 判断路由是否激活（选中状态）
        isRouteActive(link) {
            // 精确匹配根路由，其他路由模糊匹配（支持子路由）
            if (link === '/' && this.$route.path === '/') return true;
            return this.$route.path.startsWith(link) && link !== '/';
        }
    }
}
</script>

<style scoped>
/* 保留原样式，仅添加高亮和横杠相关样式 */
/* .alin{
    width: 100%;
    height:0px;
    padding: 0;
    margin: 0;
} */
.mainmenu {
    display: flex;
    gap: 1.5rem;
    /* 导航项间距（英文长文案下收紧，避免挤占 logo/右侧空间） */
    list-style: none;
    padding: 0;
    margin: 0;
    align-items: center;
}

/* 导航链接基础样式 */
.nav-link {
    text-decoration: none;
    padding: 1rem 0;
    /* 上下内边距，控制横杠位置 */
    color: #333;
    /* 默认文字颜色 */
    font-size: .9375rem;
    font-weight: 500;
    position: relative;
    /* 为横杠定位做准备 */
    transition: color 0.3s ease;
    /* 文字颜色过渡动画 */
    display: inline-block;
}

/* 鼠标悬浮 + 选中状态：文字高亮 */
.nav-link:hover,
.nav-link.active {
    color: #FFD200 !important;
    /* 高亮文字颜色（与横杠同色） */
}

/* 底部横杠：默认隐藏 */
.nav-bar {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 0;
    height: 3px;
    /* 横杠高度 */
    background-color: #FFD200 !important;
    /* 横杠颜色 */
    transition: width 0.3s ease;
    /* 横杠展开动画 */
    border-radius: 2px;
    /* 横杠圆角，可选 */
}

/* 鼠标悬浮 + 选中状态：横杠展开 */
.nav-link.active .nav-bar {
    width: 100%;
    /* 横杠铺满链接宽度 */
}

/* 下拉菜单样式（仅当hasDropdown为true且有数据时显示） */
.has-droupdown {
    position: relative;
}

.submenu {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 200px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    list-style: none;
    padding: 0.5rem 0;
    margin: 0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    z-index: 99;
    display: none;
}

.has-droupdown:hover .submenu {
    display: block;
}

.submenu li a {
    display: block;
    padding: 0.5rem 1rem;
    text-decoration: none;
    color: #333;
    position: relative;
    transition: all 0.3s ease;
}

.submenu li a:hover,
.submenu li a.active {
    color: #FFD200 !important;
    background-color: #faf6ed;
    /* 下拉项hover背景色，可选 */
}

.submenu li a .nav-bar {
    height: 2px;
    /* 下拉项横杠稍窄 */
}

/* 巨型菜单样式（仅当megamenu为true且有数据时显示） */
.with-megamenu {
    position: relative;
}

.rn-megamenu {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    z-index: 99;
    padding: 1rem;
    display: none;
}

.with-megamenu:hover .rn-megamenu {
    display: block;
}

.single-mega-item .mega-menu-item {
    list-style: none;
    padding: 0;
    margin: 0;
}

.single-mega-item .mega-menu-item li a {
    display: block;
    padding: 0.5rem 0;
    text-decoration: none;
    color: #333;
    position: relative;
    transition: all 0.3s ease;
}

.single-mega-item .mega-menu-item li a:hover,
.single-mega-item .mega-menu-item li a.active {
    color: #FFD200 !important;
}

/* 响应式调整（可选，避免移动端布局错乱） */
@media (max-width: 768px) {
    .mainmenu {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }

    .nav-link {
        padding: 0.8rem 0;
    }
}
</style>